import { STATE_KEY_NAME } from './constants'

export const getLocalStateForLeftColumn = state => state[STATE_KEY_NAME]

export const getIsCollapsed = state => state.isCollapsed
